const en = {
  'team.seoTitle': 'Team | 2A Yo-Yo Players',
  'team.seoDescription': 'Meet the YCH-YOYO team and athletes behind our performance yo-yo store and 2A yo-yo community.',
  'team.title': 'YCH-YOYO Team Members',
  'stories.seoTitle': 'Stories',
  'stories.seoDescription': 'Learn the story of YCH-YOYO and founder Yi Chenghao, including major competition achievements and videos.',
  'stories.brandTitle': 'What is YCH-YOYO?',
  'stories.brandBody': "YCH-YOYO is a private trendy toy brand founded by Yi Chenghao, a Chinese 2A yo-yo Asian champion, under Shantou Yi Chenghao Cultural Technology Co., Ltd. The brand creates yo-yos, accessories, fashion, and customized products for young players. Its simple, bold designs and strong value represent persistence and the belief that everyone can become their own champion. Yi Chenghao won China's 2A Yo-Yo Championship from 2015 to 2019 and the Asian Yo-Yo Championship in 2018, and has appeared in major television and online talent shows.",
  'stories.imageAlt': 'Yi Chenghao representing YCH-YOYO',
  'stories.who': 'Who is Yi Chenghao?',
  'stories.legend': 'A Legend and Innovator in the Yo-Yo World',
  'stories.founder': 'About the Founder',
  'stories.founderBody': 'Yi Chenghao, born in Chenghai, Shantou, Guangdong, is a renowned yo-yo player and entrepreneur. His journey with yo-yos began in 2008 after he discovered them through the TV drama Blazing Teens. In 2010, he started exploring yo-yo tricks, and by 2012, he was fully committed to mastering the 2A dual-hand looping category.',
  'stories.achievements': 'Achievements in Competitions',
  'stories.achievement1': '2015–2019: Five-time National Champion in China Yo-Yo 2A Division',
  'stories.achievement2': "2018: Champion of the Singapore Asia Yo-Yo Championship 2A Division (China's first 2A champion)",
  'stories.achievement3': '2017: 4th place, Iceland World Yo-Yo Championship 2A Division',
  'stories.achievement4': '2018: 5th place, Shanghai World Yo-Yo Championship 2A Division',
  'stories.videoTitle': 'Chenghao Yi TikTok Talent Show YCH-YOYO Store Video',
  'guide.seoTitle': 'BlitzBall vs Wind Ball Guide',
  'guide.seoDescription': 'Compare BlitzBall and Wind Ball by play feel, speed, control, and player level to choose the right yo-yo.',
  'guide.schemaHeadline': 'BlitzBall vs Wind Ball: Which Yo-Yo Should You Choose?',
  'guide.schemaDescription': 'A practical comparison between BlitzBall and Wind Ball, covering speed, control, and recommended player level.',
  'guide.title': 'BlitzBall vs Wind Ball: Which One Fits Your Style?',
  'guide.intro': 'If you are deciding between BlitzBall and Wind Ball, the short answer is: BlitzBall is balanced and forgiving, while Wind Ball is faster and more aggressive for speed-focused looping.',
  'guide.comparison': 'Quick Comparison',
  'guide.dimension': 'Dimension',
  'guide.playFeel': 'Play Feel',
  'guide.blitzFeel': 'Balanced and stable',
  'guide.windFeel': 'Fast and responsive',
  'guide.bestFor': 'Best For',
  'guide.blitzBest': 'New to intermediate 2A players',
  'guide.windBest': 'Players chasing speed and rhythm',
  'guide.tuning': 'Tuning Style',
  'guide.blitzTuning': 'Flexible everyday setup',
  'guide.windTuning': 'Specialized looping setup',
  'guide.use': 'Typical Use',
  'guide.blitzUse': 'Progression and consistency',
  'guide.windUse': 'Fast combo execution',
  'guide.recommendation': 'Recommendation by Player Type',
  'guide.recommendationBody': 'Choose BlitzBall if you want one reliable model for learning and daily training. Choose Wind Ball if you already have stable basics and want a quicker response for advanced loops.',
  'guide.related': 'Related Products',
  'guide.viewBlitz': 'View BlitzBall',
  'guide.viewWind': 'View Wind Ball',
};

const ja = {
  'team.seoTitle': 'チーム | 2Aヨーヨープレイヤー',
  'team.seoDescription': 'YCH-YOYOのパフォーマンスヨーヨーと2Aコミュニティを支えるチームと選手をご紹介します。',
  'team.title': 'YCH-YOYO チームメンバー',
  'stories.seoTitle': 'ストーリー',
  'stories.seoDescription': 'YCH-YOYOと創設者Yi Chenghaoの歩み、主な大会実績、映像をご覧ください。',
  'stories.brandTitle': 'YCH-YOYOとは？',
  'stories.brandBody': 'YCH-YOYOは、中国の2Aヨーヨー・アジアチャンピオンYi Chenghaoが汕頭Yi Chenghao文化科技有限公司のもとで設立したトレンドトイブランドです。若いプレイヤーに向けて、ヨーヨー、アクセサリー、ファッション、カスタム製品を展開しています。シンプルで力強いデザインと優れた価値を通して、粘り強さと「誰もが自分自身のチャンピオンになれる」という信念を表現しています。Yi Chenghaoは2015年から2019年まで中国2Aヨーヨー選手権を制し、2018年にはアジア選手権で優勝。テレビやオンラインの大型オーディション番組にも出演しています。',
  'stories.imageAlt': 'YCH-YOYOを代表するYi Chenghao',
  'stories.who': 'Yi Chenghaoとは？',
  'stories.legend': 'ヨーヨー界のレジェンドと革新者',
  'stories.founder': '創設者について',
  'stories.founderBody': '広東省汕頭市澄海出身のYi Chenghaoは、著名なヨーヨープレイヤーであり起業家です。2008年にテレビドラマ「Blazing Teens」をきっかけにヨーヨーと出会い、2010年から技を学び始め、2012年には2A両手ルーピングの習得に本格的に取り組みました。',
  'stories.achievements': '大会実績',
  'stories.achievement1': '2015–2019：中国全国ヨーヨー選手権2A部門 5連覇',
  'stories.achievement2': '2018：シンガポール・アジアヨーヨー選手権2A部門 優勝（中国初の2A王者）',
  'stories.achievement3': '2017：アイスランド世界ヨーヨー選手権2A部門 4位',
  'stories.achievement4': '2018：上海世界ヨーヨー選手権2A部門 5位',
  'stories.videoTitle': 'Yi Chenghao TikTokオーディション YCH-YOYOストア映像',
  'guide.seoTitle': 'BlitzBallとWind Ballの比較ガイド',
  'guide.seoDescription': 'プレイ感、スピード、操作性、レベルからBlitzBallとWind Ballを比較し、自分に合うヨーヨーを選びましょう。',
  'guide.schemaHeadline': 'BlitzBallとWind Ball：どちらを選ぶべき？',
  'guide.schemaDescription': 'BlitzBallとWind Ballのスピード、操作性、推奨レベルを比較する実用ガイドです。',
  'guide.title': 'BlitzBallとWind Ball：あなたのスタイルに合うのは？',
  'guide.intro': 'BlitzBallとWind Ballで迷っているなら、要点はシンプルです。BlitzBallはバランスがよく扱いやすく、Wind Ballはスピード重視のルーピング向けに、より速く積極的な反応をします。',
  'guide.comparison': 'クイック比較',
  'guide.dimension': '比較項目',
  'guide.playFeel': 'プレイ感',
  'guide.blitzFeel': '安定したバランス',
  'guide.windFeel': '速く反応が機敏',
  'guide.bestFor': 'おすすめ',
  'guide.blitzBest': '2A初心者から中級者',
  'guide.windBest': 'スピードとリズムを求めるプレイヤー',
  'guide.tuning': 'セッティング',
  'guide.blitzTuning': '日常的に使いやすい柔軟な設定',
  'guide.windTuning': 'ルーピング特化の設定',
  'guide.use': '主な用途',
  'guide.blitzUse': '上達と安定性',
  'guide.windUse': '高速コンボの実行',
  'guide.recommendation': 'プレイヤー別おすすめ',
  'guide.recommendationBody': '学習や毎日の練習に信頼できる1モデルを求めるならBlitzBallがおすすめです。基礎が安定し、高度なループでより速い反応を求めるならWind Ballを選びましょう。',
  'guide.related': '関連商品',
  'guide.viewBlitz': 'BlitzBallを見る',
  'guide.viewWind': 'Wind Ballを見る',
};

const zhCN = {
  'team.seoTitle': '团队 | 2A 悠悠球选手',
  'team.seoDescription': '认识 YCH-YOYO 高性能悠悠球商店与 2A 悠悠球社区背后的团队和选手。',
  'team.title': 'YCH-YOYO 团队成员',
  'stories.seoTitle': '品牌故事',
  'stories.seoDescription': '了解 YCH-YOYO 与创始人易成浩的故事、重要赛事成绩和视频。',
  'stories.brandTitle': '什么是 YCH-YOYO？',
  'stories.brandBody': 'YCH-YOYO 是由中国 2A 悠悠球亚洲冠军易成浩在汕头市易成浩文化科技有限公司旗下创立的潮流玩具品牌。品牌面向年轻玩家，提供悠悠球、配件、潮流服饰和定制产品。简洁、酷炫且高性价比的设计，表达了坚持不懈和“每个人都能成为自己的冠军”的信念。易成浩于 2015 至 2019 年连续获得中国悠悠球锦标赛 2A 冠军，并于 2018 年获得亚洲悠悠球锦标赛冠军，也曾参与多档电视与网络才艺节目。',
  'stories.imageAlt': '代表 YCH-YOYO 的易成浩',
  'stories.who': '易成浩是谁？',
  'stories.legend': '悠悠球世界的传奇与创新者',
  'stories.founder': '关于创始人',
  'stories.founderBody': '易成浩出生于广东汕头澄海，是知名悠悠球选手和创业者。2008 年，他通过电视剧《火力少年王》第一次接触悠悠球；2010 年开始研究悠悠球招式；到 2012 年，他已全心投入 2A 双手回旋技术的训练。',
  'stories.achievements': '赛事成绩',
  'stories.achievement1': '2015–2019：中国悠悠球锦标赛 2A 组五连冠',
  'stories.achievement2': '2018：新加坡亚洲悠悠球锦标赛 2A 组冠军（中国首位 2A 亚洲冠军）',
  'stories.achievement3': '2017：冰岛世界悠悠球锦标赛 2A 组第 4 名',
  'stories.achievement4': '2018：上海世界悠悠球锦标赛 2A 组第 5 名',
  'stories.videoTitle': '易成浩 TikTok 达人秀 YCH-YOYO 商店视频',
  'guide.seoTitle': 'BlitzBall 与 Wind Ball 对比指南',
  'guide.seoDescription': '从手感、速度、操控和玩家水平比较 BlitzBall 与 Wind Ball，选择适合你的悠悠球。',
  'guide.schemaHeadline': 'BlitzBall 与 Wind Ball：该选哪一款悠悠球？',
  'guide.schemaDescription': '从速度、操控和推荐玩家水平对比 BlitzBall 与 Wind Ball 的实用指南。',
  'guide.title': 'BlitzBall 与 Wind Ball：哪一款适合你的风格？',
  'guide.intro': '如果你正在 BlitzBall 和 Wind Ball 之间选择，简短答案是：BlitzBall 均衡且容易上手，而 Wind Ball 速度更快、反应更直接，更适合追求高速回旋的玩家。',
  'guide.comparison': '快速对比',
  'guide.dimension': '对比维度',
  'guide.playFeel': '操作手感',
  'guide.blitzFeel': '均衡稳定',
  'guide.windFeel': '快速灵敏',
  'guide.bestFor': '适合玩家',
  'guide.blitzBest': '2A 初学者至中级玩家',
  'guide.windBest': '追求速度与节奏的玩家',
  'guide.tuning': '调校方式',
  'guide.blitzTuning': '灵活的日常配置',
  'guide.windTuning': '专门的回旋配置',
  'guide.use': '典型用途',
  'guide.blitzUse': '进阶与稳定训练',
  'guide.windUse': '高速连招执行',
  'guide.recommendation': '按玩家类型推荐',
  'guide.recommendationBody': '如果你想要一款适合学习和日常训练的可靠型号，请选择 BlitzBall。如果你的基础已经稳定，并希望高级回旋获得更快响应，请选择 Wind Ball。',
  'guide.related': '相关商品',
  'guide.viewBlitz': '查看 BlitzBall',
  'guide.viewWind': '查看 Wind Ball',
};

const zhTW = {
  'team.seoTitle': '團隊 | 2A 溜溜球選手',
  'team.seoDescription': '認識 YCH-YOYO 高性能溜溜球商店與 2A 溜溜球社群背後的團隊和選手。',
  'team.title': 'YCH-YOYO 團隊成員',
  'stories.seoTitle': '品牌故事',
  'stories.seoDescription': '了解 YCH-YOYO 與創辦人易成浩的故事、重要賽事成績和影片。',
  'stories.brandTitle': '什麼是 YCH-YOYO？',
  'stories.brandBody': 'YCH-YOYO 是由中國 2A 溜溜球亞洲冠軍易成浩在汕頭市易成浩文化科技有限公司旗下創立的潮流玩具品牌。品牌面向年輕玩家，提供溜溜球、配件、潮流服飾和客製產品。簡潔、酷炫且高性價比的設計，表達了堅持不懈和「每個人都能成為自己的冠軍」的信念。易成浩於 2015 至 2019 年連續獲得中國溜溜球錦標賽 2A 冠軍，並於 2018 年獲得亞洲溜溜球錦標賽冠軍，也曾參與多個電視與網路才藝節目。',
  'stories.imageAlt': '代表 YCH-YOYO 的易成浩',
  'stories.who': '易成浩是誰？',
  'stories.legend': '溜溜球世界的傳奇與創新者',
  'stories.founder': '關於創辦人',
  'stories.founderBody': '易成浩出生於廣東汕頭澄海，是知名溜溜球選手和創業者。2008 年，他透過電視劇《火力少年王》第一次接觸溜溜球；2010 年開始研究溜溜球招式；到 2012 年，他已全心投入 2A 雙手迴旋技術的訓練。',
  'stories.achievements': '賽事成績',
  'stories.achievement1': '2015–2019：中國溜溜球錦標賽 2A 組五連冠',
  'stories.achievement2': '2018：新加坡亞洲溜溜球錦標賽 2A 組冠軍（中國首位 2A 亞洲冠軍）',
  'stories.achievement3': '2017：冰島世界溜溜球錦標賽 2A 組第 4 名',
  'stories.achievement4': '2018：上海世界溜溜球錦標賽 2A 組第 5 名',
  'stories.videoTitle': '易成浩 TikTok 達人秀 YCH-YOYO 商店影片',
  'guide.seoTitle': 'BlitzBall 與 Wind Ball 對比指南',
  'guide.seoDescription': '從手感、速度、操控和玩家程度比較 BlitzBall 與 Wind Ball，選擇適合你的溜溜球。',
  'guide.schemaHeadline': 'BlitzBall 與 Wind Ball：該選哪一款溜溜球？',
  'guide.schemaDescription': '從速度、操控和推薦玩家程度對比 BlitzBall 與 Wind Ball 的實用指南。',
  'guide.title': 'BlitzBall 與 Wind Ball：哪一款適合你的風格？',
  'guide.intro': '如果你正在 BlitzBall 和 Wind Ball 之間選擇，簡短答案是：BlitzBall 均衡且容易上手，而 Wind Ball 速度更快、反應更直接，更適合追求高速迴旋的玩家。',
  'guide.comparison': '快速對比',
  'guide.dimension': '對比面向',
  'guide.playFeel': '操作手感',
  'guide.blitzFeel': '均衡穩定',
  'guide.windFeel': '快速靈敏',
  'guide.bestFor': '適合玩家',
  'guide.blitzBest': '2A 初學者至中級玩家',
  'guide.windBest': '追求速度與節奏的玩家',
  'guide.tuning': '調校方式',
  'guide.blitzTuning': '靈活的日常配置',
  'guide.windTuning': '專門的迴旋配置',
  'guide.use': '典型用途',
  'guide.blitzUse': '進階與穩定訓練',
  'guide.windUse': '高速連招執行',
  'guide.recommendation': '按玩家類型推薦',
  'guide.recommendationBody': '如果你想要一款適合學習和日常訓練的可靠型號，請選擇 BlitzBall。如果你的基礎已經穩定，並希望高階迴旋獲得更快反應，請選擇 Wind Ball。',
  'guide.related': '相關商品',
  'guide.viewBlitz': '查看 BlitzBall',
  'guide.viewWind': '查看 Wind Ball',
};

const fr = {
  'team.seoTitle': 'Équipe | Joueurs de yo-yo 2A',
  'team.seoDescription': "Découvrez l'équipe et les athlètes derrière la boutique de yo-yos de performance YCH-YOYO et sa communauté 2A.",
  'team.title': "Membres de l'équipe YCH-YOYO",
  'stories.seoTitle': 'Histoires',
  'stories.seoDescription': "Découvrez l'histoire de YCH-YOYO et de son fondateur Yi Chenghao, ses principaux résultats et ses vidéos.",
  'stories.brandTitle': "Qu'est-ce que YCH-YOYO ?",
  'stories.brandBody': "YCH-YOYO est une marque indépendante de jouets tendance fondée par Yi Chenghao, champion asiatique chinois de yo-yo 2A, au sein de Shantou Yi Chenghao Cultural Technology Co., Ltd. La marque crée des yo-yos, accessoires, vêtements et produits personnalisés pour les jeunes joueurs. Ses designs simples, audacieux et accessibles incarnent la persévérance et l'idée que chacun peut devenir son propre champion. Yi Chenghao a remporté le championnat chinois de yo-yo 2A de 2015 à 2019 et le championnat asiatique en 2018, et a participé à de grandes émissions de télévision et de talents en ligne.",
  'stories.imageAlt': 'Yi Chenghao représentant YCH-YOYO',
  'stories.who': 'Qui est Yi Chenghao ?',
  'stories.legend': 'Une légende et un innovateur du monde du yo-yo',
  'stories.founder': 'À propos du fondateur',
  'stories.founderBody': "Né à Chenghai, Shantou, dans le Guangdong, Yi Chenghao est un joueur de yo-yo et entrepreneur reconnu. Il découvre le yo-yo en 2008 grâce à la série télévisée Blazing Teens. En 2010, il commence à explorer les figures et, dès 2012, se consacre pleinement à la maîtrise du looping à deux mains en catégorie 2A.",
  'stories.achievements': 'Résultats en compétition',
  'stories.achievement1': '2015–2019 : cinq fois champion national de Chine en catégorie yo-yo 2A',
  'stories.achievement2': "2018 : champion d'Asie de yo-yo à Singapour en catégorie 2A (premier champion chinois de 2A)",
  'stories.achievement3': '2017 : 4e place au championnat du monde de yo-yo en Islande, catégorie 2A',
  'stories.achievement4': '2018 : 5e place au championnat du monde de yo-yo à Shanghai, catégorie 2A',
  'stories.videoTitle': 'Vidéo YCH-YOYO de Yi Chenghao au concours de talents TikTok',
  'guide.seoTitle': 'Guide BlitzBall ou Wind Ball',
  'guide.seoDescription': 'Comparez BlitzBall et Wind Ball selon les sensations, la vitesse, le contrôle et le niveau pour choisir le bon yo-yo.',
  'guide.schemaHeadline': 'BlitzBall ou Wind Ball : quel yo-yo choisir ?',
  'guide.schemaDescription': 'Une comparaison pratique de BlitzBall et Wind Ball selon la vitesse, le contrôle et le niveau recommandé.',
  'guide.title': 'BlitzBall ou Wind Ball : lequel correspond à votre style ?',
  'guide.intro': "Si vous hésitez entre BlitzBall et Wind Ball, la réponse courte est la suivante : BlitzBall est équilibré et tolérant, tandis que Wind Ball est plus rapide et plus agressif pour le looping axé sur la vitesse.",
  'guide.comparison': 'Comparaison rapide',
  'guide.dimension': 'Critère',
  'guide.playFeel': 'Sensations',
  'guide.blitzFeel': 'Équilibré et stable',
  'guide.windFeel': 'Rapide et réactif',
  'guide.bestFor': 'Idéal pour',
  'guide.blitzBest': 'Joueurs 2A débutants à intermédiaires',
  'guide.windBest': 'Joueurs recherchant vitesse et rythme',
  'guide.tuning': 'Réglage',
  'guide.blitzTuning': 'Configuration quotidienne polyvalente',
  'guide.windTuning': 'Configuration spécialisée pour le looping',
  'guide.use': 'Usage type',
  'guide.blitzUse': 'Progression et régularité',
  'guide.windUse': 'Exécution de combos rapides',
  'guide.recommendation': 'Recommandation par profil de joueur',
  'guide.recommendationBody': "Choisissez BlitzBall si vous recherchez un modèle fiable pour apprendre et vous entraîner chaque jour. Choisissez Wind Ball si vos bases sont solides et que vous souhaitez une réponse plus rapide pour les loops avancés.",
  'guide.related': 'Produits associés',
  'guide.viewBlitz': 'Voir BlitzBall',
  'guide.viewWind': 'Voir Wind Ball',
};

const es = {
  'team.seoTitle': 'Equipo | Jugadores de yo-yo 2A',
  'team.seoDescription': 'Conoce al equipo y a los atletas detrás de la tienda de yo-yos de rendimiento YCH-YOYO y su comunidad 2A.',
  'team.title': 'Miembros del equipo YCH-YOYO',
  'stories.seoTitle': 'Historias',
  'stories.seoDescription': 'Conoce la historia de YCH-YOYO y de su fundador Yi Chenghao, sus principales logros y vídeos.',
  'stories.brandTitle': '¿Qué es YCH-YOYO?',
  'stories.brandBody': 'YCH-YOYO es una marca independiente de juguetes de tendencia fundada por Yi Chenghao, campeón asiático chino de yo-yo 2A, bajo Shantou Yi Chenghao Cultural Technology Co., Ltd. La marca crea yo-yos, accesorios, moda y productos personalizados para jóvenes jugadores. Sus diseños sencillos, atrevidos y de gran valor representan la perseverancia y la idea de que todos pueden convertirse en su propio campeón. Yi Chenghao ganó el Campeonato Chino de Yo-Yo 2A de 2015 a 2019 y el Campeonato Asiático en 2018, y ha participado en importantes programas de televisión y concursos de talentos en línea.',
  'stories.imageAlt': 'Yi Chenghao representando a YCH-YOYO',
  'stories.who': '¿Quién es Yi Chenghao?',
  'stories.legend': 'Una leyenda e innovador del mundo del yo-yo',
  'stories.founder': 'Sobre el fundador',
  'stories.founderBody': 'Yi Chenghao, nacido en Chenghai, Shantou, Guangdong, es un reconocido jugador de yo-yo y emprendedor. Comenzó su viaje en 2008 tras descubrir el yo-yo en la serie de televisión Blazing Teens. En 2010 empezó a explorar trucos y, para 2012, ya estaba plenamente dedicado a dominar el looping a dos manos de la categoría 2A.',
  'stories.achievements': 'Logros en competiciones',
  'stories.achievement1': '2015–2019: cinco veces campeón nacional de China en la división de yo-yo 2A',
  'stories.achievement2': '2018: campeón de Asia de yo-yo en Singapur, división 2A (primer campeón chino de 2A)',
  'stories.achievement3': '2017: 4.º puesto en el Campeonato Mundial de Yo-Yo de Islandia, división 2A',
  'stories.achievement4': '2018: 5.º puesto en el Campeonato Mundial de Yo-Yo de Shanghái, división 2A',
  'stories.videoTitle': 'Vídeo de Yi Chenghao en el concurso de talentos TikTok de YCH-YOYO',
  'guide.seoTitle': 'Guía BlitzBall vs Wind Ball',
  'guide.seoDescription': 'Compara BlitzBall y Wind Ball por sensaciones, velocidad, control y nivel para elegir el yo-yo adecuado.',
  'guide.schemaHeadline': 'BlitzBall vs Wind Ball: ¿qué yo-yo deberías elegir?',
  'guide.schemaDescription': 'Una comparación práctica entre BlitzBall y Wind Ball que cubre velocidad, control y nivel recomendado.',
  'guide.title': 'BlitzBall vs Wind Ball: ¿cuál encaja con tu estilo?',
  'guide.intro': 'Si estás decidiendo entre BlitzBall y Wind Ball, la respuesta corta es: BlitzBall es equilibrado y permisivo, mientras que Wind Ball es más rápido y agresivo para el looping centrado en la velocidad.',
  'guide.comparison': 'Comparación rápida',
  'guide.dimension': 'Aspecto',
  'guide.playFeel': 'Sensación de juego',
  'guide.blitzFeel': 'Equilibrado y estable',
  'guide.windFeel': 'Rápido y reactivo',
  'guide.bestFor': 'Ideal para',
  'guide.blitzBest': 'Jugadores 2A principiantes e intermedios',
  'guide.windBest': 'Jugadores que buscan velocidad y ritmo',
  'guide.tuning': 'Tipo de ajuste',
  'guide.blitzTuning': 'Configuración diaria flexible',
  'guide.windTuning': 'Configuración especializada de looping',
  'guide.use': 'Uso habitual',
  'guide.blitzUse': 'Progresión y constancia',
  'guide.windUse': 'Ejecución de combos rápidos',
  'guide.recommendation': 'Recomendación por tipo de jugador',
  'guide.recommendationBody': 'Elige BlitzBall si quieres un modelo fiable para aprender y entrenar a diario. Elige Wind Ball si ya tienes una base sólida y quieres una respuesta más rápida para loops avanzados.',
  'guide.related': 'Productos relacionados',
  'guide.viewBlitz': 'Ver BlitzBall',
  'guide.viewWind': 'Ver Wind Ball',
};

const ko = {
  'team.seoTitle': '팀 | 2A 요요 플레이어',
  'team.seoDescription': 'YCH-YOYO 퍼포먼스 요요 스토어와 2A 커뮤니티를 만드는 팀과 선수들을 만나보세요.',
  'team.title': 'YCH-YOYO 팀 멤버',
  'stories.seoTitle': '스토리',
  'stories.seoDescription': 'YCH-YOYO와 창립자 Yi Chenghao의 이야기, 주요 대회 성적과 영상을 확인하세요.',
  'stories.brandTitle': 'YCH-YOYO란?',
  'stories.brandBody': 'YCH-YOYO는 중국 2A 요요 아시아 챔피언 Yi Chenghao가 Shantou Yi Chenghao Cultural Technology Co., Ltd. 산하에 설립한 독립 트렌드 완구 브랜드입니다. 젊은 플레이어를 위해 요요, 액세서리, 패션, 맞춤 제품을 만듭니다. 단순하고 대담하며 가치 있는 디자인은 끈기와 누구나 자신만의 챔피언이 될 수 있다는 믿음을 담고 있습니다. Yi Chenghao는 2015년부터 2019년까지 중국 2A 요요 챔피언십에서 우승했고 2018년 아시아 챔피언에 올랐으며, 주요 TV 및 온라인 오디션 프로그램에도 출연했습니다.',
  'stories.imageAlt': 'YCH-YOYO를 대표하는 Yi Chenghao',
  'stories.who': 'Yi Chenghao는 누구인가요?',
  'stories.legend': '요요 세계의 전설이자 혁신가',
  'stories.founder': '창립자 소개',
  'stories.founderBody': '광둥성 산터우 청하이에서 태어난 Yi Chenghao는 저명한 요요 플레이어이자 기업가입니다. 2008년 TV 드라마 Blazing Teens를 통해 요요를 처음 접했고, 2010년부터 트릭을 연구하기 시작해 2012년에는 2A 양손 루핑 기술에 전념했습니다.',
  'stories.achievements': '대회 성적',
  'stories.achievement1': '2015–2019: 중국 전국 요요 챔피언십 2A 부문 5회 우승',
  'stories.achievement2': '2018: 싱가포르 아시아 요요 챔피언십 2A 부문 우승(중국 최초 2A 챔피언)',
  'stories.achievement3': '2017: 아이슬란드 세계 요요 챔피언십 2A 부문 4위',
  'stories.achievement4': '2018: 상하이 세계 요요 챔피언십 2A 부문 5위',
  'stories.videoTitle': 'Yi Chenghao TikTok 오디션 YCH-YOYO 스토어 영상',
  'guide.seoTitle': 'BlitzBall 대 Wind Ball 가이드',
  'guide.seoDescription': '플레이 감각, 속도, 컨트롤과 플레이어 수준으로 BlitzBall과 Wind Ball을 비교해 알맞은 요요를 선택하세요.',
  'guide.schemaHeadline': 'BlitzBall 대 Wind Ball: 어떤 요요를 선택해야 할까요?',
  'guide.schemaDescription': '속도, 컨트롤과 권장 수준을 기준으로 BlitzBall과 Wind Ball을 비교하는 실용 가이드입니다.',
  'guide.title': 'BlitzBall 대 Wind Ball: 내 스타일에 맞는 모델은?',
  'guide.intro': 'BlitzBall과 Wind Ball 중 고민한다면 답은 간단합니다. BlitzBall은 균형 잡히고 다루기 쉬우며, Wind Ball은 속도 중심 루핑을 위해 더 빠르고 적극적으로 반응합니다.',
  'guide.comparison': '빠른 비교',
  'guide.dimension': '비교 항목',
  'guide.playFeel': '플레이 감각',
  'guide.blitzFeel': '균형 잡히고 안정적',
  'guide.windFeel': '빠르고 민첩함',
  'guide.bestFor': '추천 대상',
  'guide.blitzBest': '2A 초급부터 중급 플레이어',
  'guide.windBest': '속도와 리듬을 추구하는 플레이어',
  'guide.tuning': '세팅 방식',
  'guide.blitzTuning': '유연한 일상 세팅',
  'guide.windTuning': '루핑 특화 세팅',
  'guide.use': '주요 용도',
  'guide.blitzUse': '성장과 일관성',
  'guide.windUse': '고속 콤보 실행',
  'guide.recommendation': '플레이어 유형별 추천',
  'guide.recommendationBody': '학습과 매일 훈련에 믿을 수 있는 한 모델을 원한다면 BlitzBall을 선택하세요. 기본기가 안정적이고 고급 루프에서 더 빠른 반응을 원한다면 Wind Ball을 선택하세요.',
  'guide.related': '관련 제품',
  'guide.viewBlitz': 'BlitzBall 보기',
  'guide.viewWind': 'Wind Ball 보기',
};

export const contentTranslations = { en, ja, 'zh-CN': zhCN, 'zh-TW': zhTW, fr, es, ko };
